// 🔧 store_step.js
// ✅ Purpose: Pipeline step for the LGV Event Merch Store Engine
// ✅ Features:
// - Executes the Store Engine when Event Merch Store is selected
// - Integrates with shared DemoContext
// - Returns standardized pipeline results
// - Fully block-commented for clarity and future devs

import { runStoreEngine } from "../../engines/store";

export const createStoreStep = () => ({
  id: "store_builder",

  name: "Store Builder",

  label: "Store Builder",

  run: async (demoContext) => {
    console.log("🛒 Store Pipeline Step started.");

    const result = await runStoreEngine({
      demoContext,
    });

    console.log("✅ Store Pipeline Step completed.", {
      result,
    });

    return result;
  },
});